const allMutations = {
  rt: {
    // Not found
    40: {
      cons: 'E',
      options: [{ "value": "40F", "label": "F" }, { "value": "40*", "label": "*" }]
    },
    44: {
      cons: 'E',
      options: [{ "value": "44A", "label": "A" }, { "value": "44D", "label": "D" }, { "value": "44*", "label": "*" }]
    },
    62: {
      cons: 'A',
      options: [{ "value": "62V", "label": "V" }, { "value": "62*", "label": "*" }]
    },
    68: {
      cons: 'S',
      options: [{ "value": "68del", "label": "del" }, { "value": "68*", "label": "*" }]
    },
    75: {
      cons: 'V',
      options: [{ "value": "75A", "label": "A" }, { "value": "75I", "label": "I" }, { "value": "75L", "label": "L" }, { "value": "75M", "label": "M" }, { "value": "75S", "label": "S" }, { "value": "75T", "label": "T" }, { "value": "75*", "label": "*" }]
    },
    77: {
      cons: 'F',
      options: [{ "value": "77L", "label": "L" }, { "value": "77*", "label": "*" }]
    },
    90: {
      cons: 'V',
      options: [{ "value": "90I", "label": "I" }, { "value": "90*", "label": "*" }]
    },
    98: {
      cons: 'A',
      options: [{ "value": "98G", "label": "G" }, { "value": "98*", "label": "*" }]
    },
    108: {
      cons: 'V',
      options: [{ "value": "108I", "label": "I" }, { "value": "108*", "label": "*" }]
    },
    116: {
      cons: 'F',
      options: [{ "value": "116Y", "label": "Y" }, { "value": "116*", "label": "*" }]
    },
    179: {
      cons: 'V',
      options: [{ "value": "179D", "label": "D" }, { "value": "179E", "label": "E" }, { "value": "179F", "label": "F" }, { "value": "179L", "label": "L" }, { "value": "179T", "label": "T" }, { "value": "179*", "label": "*" }]
    },
    221: {
      cons: 'H',
      options: [{ "value": "221Y", "label": "Y" }, { "value": "221*", "label": "*" }]
    },
    225: {
      cons: 'P',
      options: [{ "value": "225H", "label": "H" }, { "value": "225*", "label": "*" }]
    },
    227: {
      cons: 'F',
      options: [{ "value": "227C", "label": "C" }, { "value": "227L", "label": "L" }, { "value": "227*", "label": "*" }]
    },
    118: {
      cons: 'G',
      options: [{ "value": "118I", "label": "I" }, { "value": "118*", "label": "*" }]
    },
    // NRTI
    184: {
      cons: 'M',
      options: [{ "value": "184I", "label": "I" }, { "value": "184V", "label": "V" }, { "value": "184*", "label": "*" }]
    },
    65: {
      cons: 'K',
      options: [{ "value": "65E", "label": "E" }, { "value": "65N", "label": "N" }, { "value": "65R", "label": "R" }, { "value": "65*", "label": "*" }]
    },
    70: {
      cons: 'K',
      options: [{ "value": "70E", "label": "E" }, { "value": "70G", "label": "G" }, { "value": "70N", "label": "N" }, { "value": "70Q", "label": "Q" }, { "value": "70R", "label": "R" }, { "value": "70S", "label": "S" }, { "value": "70T", "label": "T" }, { "value": "70del", "label": "del" }, { "value": "70*", "label": "*" }]
    },
    74: {
      cons: 'L',
      options: [{ "value": "74I", "label": "I" }, { "value": "74V", "label": "V" }, { "value": "74*", "label": "*" }]
    },
    115: {
      cons: 'Y',
      options: [{ "value": "115F", "label": "F" }, { "value": "115*", "label": "*" }]
    },
    41: {
      cons: 'M',
      options: [{ "value": "41L", "label": "L" }, { "value": "41*", "label": "*" }]
    },
    67: {
      cons: 'D',
      options: [{ "value": "67E", "label": "E" }, { "value": "67G", "label": "G" }, { "value": "67H", "label": "H" }, { "value": "67N", "label": "N" }, { "value": "67S", "label": "S" }, { "value": "67T", "label": "T" }, { "value": "67del", "label": "del" }, { "value": "67*", "label": "*" }]
    },
    210: {
      cons: 'L',
      options: [{ "value": "210W", "label": "W" }, { "value": "210*", "label": "*" }]
    },
    215: {
      cons: 'T',
      options: [{ "value": "215A", "label": "A" }, { "value": "215C", "label": "C" }, { "value": "215D", "label": "D" }, { "value": "215E", "label": "E" }, { "value": "215F", "label": "F" }, { "value": "215I", "label": "I" }, { "value": "215L", "label": "L" }, { "value": "215N", "label": "N" }, { "value": "215S", "label": "S" }, { "value": "215V", "label": "V" }, { "value": "215Y", "label": "Y" }, { "value": "215*", "label": "*" }]
    },
    219: {
      cons: 'K',
      options: [{ "value": "219E", "label": "E" }, { "value": "219N", "label": "N" }, { "value": "219Q", "label": "Q" }, { "value": "219R", "label": "R" }, { "value": "219W", "label": "W" }, { "value": "219*", "label": "*" }]
    },
    69: {
      cons: 'T',
      options: [{ "value": "69D", "label": "D" }, { "value": "69G", "label": "G" }, { "value": "69N", "label": "N" }, { "value": "69del", "label": "del" }, { "value": "69ins", "label": "ins" }, { "value": "69*", "label": "*" }]
    },
    151: {
      cons: 'Q',
      options: [{ "value": "151L", "label": "L" }, { "value": "151M", "label": "M" }, { "value": "151*", "label": "*" }]
    },
    // NNRTI
    100: {
      cons: 'L',
      options: [{ "value": "100I", "label": "I" }, { "value": "100V", "label": "V" }, { "value": "100*", "label": "*" }]
    },
    101: {
      cons: 'K',
      options: [{ "value": "101E", "label": "E" }, { "value": "101H", "label": "H" }, { "value": "101N", "label": "N" }, { "value": "101P", "label": "P" }, { "value": "101Q", "label": "Q" }, { "value": "101*", "label": "*" }]
    },
    103: {
      cons: 'K',
      options: [{ "value": "103E", "label": "E" }, { "value": "103H", "label": "H" }, { "value": "103N", "label": "N" }, { "value": "103Q", "label": "Q" }, { "value": "103R", "label": "R" }, { "value": "103S", "label": "S" }, { "value": "103T", "label": "T" }, { "value": "103*", "label": "*" }]
    },
    106: {
      cons: 'V',
      options: [{ "value": "106A", "label": "A" }, { "value": "106I", "label": "I" }, { "value": "106M", "label": "M" }, { "value": "106*", "label": "*" }]
    },
    138: {
      cons: 'E',
      options: [{ "value": "138A", "label": "A" }, { "value": "138G", "label": "G" }, { "value": "138K", "label": "K" }, { "value": "138Q", "label": "Q" }, { "value": "138R", "label": "R" }, { "value": "138*", "label": "*" }]
    },
    181: {
      cons: 'Y',
      options: [{ "value": "181C", "label": "C" }, { "value": "181F", "label": "F" }, { "value": "181G", "label": "G" }, { "value": "181I", "label": "I" }, { "value": "181S", "label": "S" }, { "value": "181V", "label": "V" }, { "value": "181*", "label": "*" }]
    },
    188: {
      cons: 'Y',
      options: [{ "value": "188C", "label": "C" }, { "value": "188F", "label": "F" }, { "value": "188H", "label": "H" }, { "value": "188L", "label": "L" }, { "value": "188*", "label": "*" }]
    },
    190: {
      cons: 'G',
      options: [{ "value": "190A", "label": "A" }, { "value": "190C", "label": "C" }, { "value": "190E", "label": "E" }, { "value": "190Q", "label": "Q" }, { "value": "190S", "label": "S" }, { "value": "190T", "label": "T" }, { "value": "190V", "label": "V" }, { "value": "190*", "label": "*" }]
    },
    230: {
      cons: 'M',
      options: [{ "value": "230I", "label": "I" }, { "value": "230L", "label": "L" }, { "value": "230*", "label": "*" }]
    },
    236: {
      cons: 'P',
      options: [{ "value": "236L", "label": "L" }, { "value": "236*", "label": "*" }]
    },
    238: {
      cons: 'K',
      options: [{ "value": "238N", "label": "N" }, { "value": "238T", "label": "T" }, { "value": "238*", "label": "*" }]
    },
    318: {
      cons: 'Y',
      options: [{ "value": "318F", "label": "F" }, { "value": "318*", "label": "*" }]
    },
    348: {
      cons: 'N',
      options: [{ "value": "348I", "label": "I" }, { "value": "348*", "label": "*" }]
    }
  },
  pr: {
    10: {
      cons: 'L',
      options: [{ "value": "10F", "label": "F" }, { "value": "10I", "label": "I" }, { "value": "10R", "label": "R" }, { "value": "10V", "label": "V" }, { "value": "10Y", "label": "Y" }, { "value": "10*", "label": "*" }]
    },
    11: {
      cons: 'V',
      options: [{ "value": "11I", "label": "I" }, { "value": "11L", "label": "L" }, { "value": "11*", "label": "*" }]
    },
    13: {
      cons: 'I',
      options: [{ "value": "13V", "label": "V" }, { "value": "13*", "label": "*" }]
    },
    20: {
      cons: 'K',
      options: [{ "value": "20I", "label": "I" }, { "value": "20M", "label": "M" }, { "value": "20R", "label": "R" }, { "value": "20T", "label": "T" }, { "value": "20V", "label": "V" }, { "value": "20*", "label": "*" }]
    },
    23: {
      cons: 'L',
      options: [{ "value": "23I", "label": "I" }, { "value": "23*", "label": "*" }]
    },
    24: {
      cons: 'L',
      options: [{ "value": "24F", "label": "F" }, { "value": "24I", "label": "I" }, { "value": "24*", "label": "*" }]
    },
    30: {
      cons: 'D',
      options: [{ "value": "30N", "label": "N" }, { "value": "30*", "label": "*" }]
    },
    32: {
      cons: 'V',
      options: [{ "value": "32I", "label": "I" }, { "value": "32*", "label": "*" }]
    },
    33: {
      cons: 'L',
      options: [{ "value": "33F", "label": "F" }, { "value": "33I", "label": "I" }, { "value": "33V", "label": "V" }, { "value": "33*", "label": "*" }]
    },
    35: {
      cons: 'K',
      options: [{"value":"35G","label":"G"},{"value":"35 * ","label":" * "}]
    },
    36: {
      cons: 'M',
      options: [{ "value": "36I", "label": "I" }, { "value": "36L", "label": "L" }, { "value": "36T", "label": "T" }, { "value": "36V", "label": "V" }, { "value": "36*", "label": "*" }]
    },
    43: {
      cons: 'K',
      options: [{ "value": "43T", "label": "T" }, { "value": "43*", "label": "*" }]
    },
    46: {
      cons: 'M',
      options: [{ "value": "46I", "label": "I" }, { "value": "46L", "label": "L" }, { "value": "46V", "label": "V" }, { "value": "46*", "label": "*" }]
    },
    47: {
      cons: 'I',
      options: [{ "value": "47A", "label": "A" }, { "value": "47V", "label": "V" }, { "value": "47*", "label": "*" }]
    },
    48: {
      cons: 'G',
      options: [{ "value": "48A", "label": "A" }, { "value": "48L", "label": "L" }, { "value": "48M", "label": "M" }, { "value": "48Q", "label": "Q" }, { "value": "48S", "label": "S" }, { "value": "48T", "label": "T" }, { "value": "48V", "label": "V" }, { "value": "48*", "label": "*" }]
    },
    50: {
      cons: 'I',
      options: [{ "value": "50L", "label": "L" }, { "value": "50V", "label": "V" }, { "value": "50*", "label": "*" }]
    },
    53: {
      cons: 'F',
      options: [{ "value": "53L", "label": "L" }, { "value": "53Y", "label": "Y" }, { "value": "53*", "label": "*" }]
    },
    54: {
      cons: 'I',
      options: [{ "value": "54A", "label": "A" }, { "value": "54L", "label": "L" }, { "value": "54M", "label": "M" }, { "value": "54S", "label": "S" }, { "value": "54T", "label": "T" }, { "value": "54V", "label": "V" }, { "value": "54*", "label": "*" }]
    },
    58: {
      cons: 'Q',
      options: [{ "value": "58E", "label": "E" }, { "value": "58*", "label": "*" }]
    },
    63: {
      cons: 'L',
      options: [{ "value": "63P", "label": "P" }, { "value": "63*", "label": "*" }]
    },
    71: {
      cons: 'A',
      options: [{ "value": "71I", "label": "I" }, { "value": "71L", "label": "L" }, { "value": "71T", "label": "T" }, { "value": "71V", "label": "V" }, { "value": "71*", "label": "*" }]
    },
    73: {
      cons: 'G',
      options: [{ "value": "73A", "label": "A" }, { "value": "73C", "label": "C" }, { "value": "73D", "label": "D" }, { "value": "73S", "label": "S" }, { "value": "73T", "label": "T" }, { "value": "73V", "label": "V" }, { "value": "73*", "label": "*" }]
    },
    74: {
      cons: 'T',
      options: [{ "value": "74P", "label": "P" }, { "value": "74S", "label": "S" }, { "value": "74*", "label": "*" }]
    },
    76: {
      cons: 'L',
      options: [{ "value": "76V", "label": "V" }, { "value": "76*", "label": "*" }]
    },
    77: {
      cons: 'V',
      options: [{ "value": "77I", "label": "I" },{ "value":"77*", "label":"*"}]
    },
    82: {
      cons: 'V',
      options: [{ "value": "82A", "label": "A" }, { "value": "82C", "label": "C" }, { "value": "82F", "label": "F" }, { "value": "82I", "label": "I" }, { "value": "82L", "label": "L" }, { "value": "82M", "label": "M" }, { "value": "82S", "label": "S" }, { "value": "82T", "label": "T" }, { "value": "82*", "label": "*" }]
    },
    83: {
      cons: 'N',
      options: [{ "value": "83D", "label": "D" }, { "value": "83*", "label": "*" }]
    },
    84: {
      cons: 'I',
      options: [{ "value": "84A", "label": "A" }, { "value": "84C", "label": "C" }, { "value": "84V", "label": "V" }, { "value": "84*", "label": "*" }]
    },
    85: {
      cons: 'I',
      options: [{ "value": "85V", "label": "V" }, { "value": "85*", "label": "*" }]
    },
    88: {
      cons: 'N',
      options: [{ "value": "88D", "label": "D" }, { "value": "88G", "label": "G" }, { "value": "88S", "label": "S" }, { "value": "88T", "label": "T" }, { "value": "88*", "label": "*" }]
    },
    89: {
      cons: 'L',
      options: [{ "value": "89I", "label": "I" }, { "value": "89M", "label": "M" }, { "value": "89T", "label": "T" }, { "value": "89V", "label": "V" }, { "value": "89*", "label": "*" }]
    },
    90: {
      cons: 'L',
      options: [{"value":"90M","label":"M"},{"value":"90*","label":"*"}]
    },
    93: {
      cons: 'L',
      options: [{ "value": "93L", "label": "L" }, { "value": "93*", "label": "*" }]
    }
  },
  in: {
    51: {
      cons: 'H',
      options: [{ "value": "51Y", "label": "Y" }, { "value": "51*", "label": "*" }]
    },
    66: {
      cons: 'T',
      options: [{ "value": "66A", "label": "A" }, { "value": "66I", "label": "I" }, { "value": "66K", "label": "K" }, { "value": "66*", "label": "*" }]
    },
    74: {
      cons: 'L',
      options: [{ "value": "74I", "label": "I" }, { "value": "74M", "label": "M" }, { "value": "74*", "label": "*" }]
    },
    92: {
      cons: 'E',
      options: [{ "value": "92G", "label": "G" }, { "value": "92Q", "label": "Q" }, { "value": "92V", "label": "V" }, { "value": "92*", "label": "*" }]
    },
    95: {
      cons: 'Q',
      options: [{ "value": "95K", "label": "K" }, { "value": "95*", "label": "*" }]
    },
    97: {
      cons: 'T',
      options: [{ "value": "97A", "label": "A" }, { "value": "97*", "label": "*" }]
    },
    114: {
      cons: 'H',
      options: [{"value":"114Y","label":"Y"},{"value":"114*","label":"*"}]
    },
    118: {
      cons: 'G',
      options: [{ "value": "118R", "label": "R" }, { "value": "118*", "label": "*" }]
    },
    121: {
      cons: 'F',
      options: [{ "value": "121Y", "label": "Y" }, { "value": "121*", "label": "*" }]
    },
    128: {
      cons: 'A',
      options: [{"value":"128T","label":"T"},{"value":"128*","label":"*"}]
    },
    138: {
      cons: 'E',
      options: [{ "value": "138A", "label": "A" }, { "value": "138K", "label": "K" }, { "value": "138T", "label": "T" }, { "value": "138*", "label": "*" }]
    },
    140: {
      cons: 'G',
      options: [{ "value": "140A", "label": "A" }, { "value": "140C", "label": "C" }, { "value": "140S", "label": "S" }, { "value": "140*", "label": "*" }]
    },
    143: {
      cons: 'Y',
      options: [{ "value": "143A", "label": "A" }, { "value": "143C", "label": "C" }, { "value": "143G", "label": "G" }, { "value": "143H", "label": "H" }, { "value": "143K", "label": "K" }, { "value": "143R", "label": "R" }, { "value": "143S", "label": "S" }, { "value": "143*", "label": "*" }]
    },
    145: {
      cons: 'P',
      options: [{ "value": "145S", "label": "S" }, { "value": "145*", "label": "*" }]
    },
    146: {
      cons: 'Q',
      options: [{ "value": "146P", "label": "P" }, { "value": "146*", "label": "*" }]
    },
    147: {
      cons: 'S',
      options: [{ "value": "147G", "label": "G" }, { "value": "147*", "label": "*" }]
    },
    148: {
      cons: 'Q',
      options: [{ "value": "148H", "label": "H" }, { "value": "148K", "label": "K" }, { "value": "148N", "label": "N" }, { "value": "148R", "label": "R" }, { "value": "148*", "label": "*" }]
    },
    151: {
      cons: 'V',
      options: [{ "value": "151A", "label": "A" }, { "value": "151I", "label": "I" }, { "value": "151L", "label": "L" }, { "value": "151*", "label": "*" }]
    },
    153: {
      cons: 'S',
      options: [{ "value": "153F", "label": "F" }, { "value": "153Y", "label": "Y" }, { "value": "153*", "label": "*" }]
    },
    155: {
      cons: 'N',
      options: [{ "value": "155H", "label": "H" }, { "value": "155S", "label": "S" }, { "value": "155T", "label": "T" }, { "value": "155*", "label": "*" }]
    },
    157: {
      cons: 'E',
      options: [{ "value": "157Q", "label": "Q" }, { "value": "157*", "label": "*" }]
    },
    163: {
      cons: 'G',
      options: [{ "value": "163K", "label": "K" }, { "value": "163R", "label": "R" }, { "value": "163*", "label": "*" }]
    },
    230: {
      cons: 'S',
      options: [{ "value": "230R", "label": "R" }, { "value": "230*", "label": "*" }]
    },
    263: {
      cons: 'R',
      options: [{ "value": "263K", "label": "K" }, { "value": "263*", "label": "*" }]
    }
  }
}

const drugBrands = {
  'atazanavir/r': ["REYATAZ", "ATAZANAVIR"],
  'darunavir/r': ["PREZISTA"],
  'fosamprenavir/r': [],
  'indinavir/r': [],
  'lopinavir/r': [],
  'nelfinavir': [],
  'saquinavir/r': [],
  'ipranavir/r': [],
  'abacavir': [],
  'zidovudine': [],
  'stavudine': ["ZERIT"],
  'didanosine': ["VIDEX"],
  'emtricitabine': [],
  'lamivudine': [],
  'tenofovir': [],
  'efavirenz': [],
  'etravirine': ["INTELENCE"],
  'nevirapine': ["VIRAMUNE"],
  'rilpivirine': [],
  'bictegravir': [],
  'dolutegravir': [],
  'elvitegravir': [],
  'raltegravir': []
};

export {
  allMutations,
  drugBrands
};


// WEBPACK FOOTER //
// ./src/utils/data.js